/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { TimelineComponentDisplay } from "cms/components/components/timeline/display/index";
import { TimelineComponentEditor } from "cms/components/components/timeline/edit/index";
import { getComponentZoneLayout } from "cms/components/components/component";

const TimelineComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <TimelineComponentDisplay />,
        editComponent: <TimelineComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

TimelineComponent.displayName = "TimelineComponent";
export { TimelineComponent };
